import ProductAmmount from './ProductAmmount'
import { TitleStyled } from './styles'

const Title = (props: {
  resultsFor: string
  searchTerm: string
  itemsFound: number
}) => {
  return (
    <TitleStyled className="search-title_wrapper">
      <p className="label">
        {`${props.resultsFor} `}
        <span>{`"${props.searchTerm}"`}</span>
      </p>
      <ProductAmmount quantity={props.itemsFound} />
    </TitleStyled>
  )
}

export default Title
